<template>
    <div class="basicData sdWrap" v-wechat-title="$t('服务报告管理')">
        <Title :title="$t('客户服务报告管理')"/>
        <div class="form_box">
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('派工单') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.dispatchSn" clearable maxlength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('客户名称') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.clientName" clearable maxlength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('服务BU') }}</span></div>
                    <div class="input_box">
                        <el-select v-model="parameters.parameters.buId" clearable filterable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in buSelectOps"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('服务类型') }}</span></div>
                    <div class="input_box">
                        <el-select v-model="parameters.parameters.serviceTypeId" clearable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in serviceTypeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('报告状态') }}</span></div>
                    <div class="input_box">
                        <el-select v-model="parameters.parameters.status" clearable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in statusList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('工程师') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.engineerName" clearable maxlength="15"></el-input>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('设备编号') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.mtSn" clearable maxlength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('设备型号') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.mtModel" clearable maxlength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('服务方式') }}</span></div>
                    <div class="input_box">
                        <el-select v-model="parameters.parameters.serviceMethod" clearable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in serviceMethodList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('关键字') }}</span></div>
                    <div class="input_box">
                        <el-input  v-model.trim="parameters.parameters.keyWord" clearable maxlength="15"></el-input>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('是否等待备件') }}</span></div>
                    <div class="input_box">
                        <el-select v-model="parameters.parameters.isWaitingForComponent" clearable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in booleanList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('是否更换备件') }}</span></div>
                    <div class="input_box">
                        <el-select v-model="parameters.parameters.isChangePart" clearable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in booleanList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="form_box_line">
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('是否待观察') }}</span></div>
                    <div class="input_box">
                        <el-select v-model="parameters.parameters.isBeingObserved" clearable :placeholder="$t('请选择')">
                            <el-option
                                    v-for="item in booleanList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span>{{ $t('服务日期') }}</span></div>
                    <div class="input_box">
                        <el-date-picker v-model="parameters.parameters.createDateFrom" type="date" value-format="yyyy-MM-dd"></el-date-picker>
                    </div>
                </div>
                <div class="form_box_line_item">
                    <div class="input_title"><span style="margin-right: 90px;">~</span></div>
                    <div class="input_box">
                        <el-date-picker v-model="parameters.parameters.createDateTo" type="date" value-format="yyyy-MM-dd"></el-date-picker>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn_box">
            <button type="button" class="search_btn" @click="search">{{ $t('查询') }}</button>
            <button type="button" class="opt_btn export_btn" @click="exportExcel" v-permissions="230128" :title="$t('服务信息导出(Excel)')">{{ $t('导出') }}</button>
        </div>
        <div class="table_box">
            <el-table :data="list" v-loading="loading">
                <!-- <el-table-column label="" align="center" width="60">
                    <template slot-scope="scope">
                        <div class="mailIcon" :class="{'mailSent': scope.row.mailSent === 1, 'mailNotSent':  scope.row.mailSent !== 1}"></div>
                    </template>
                </el-table-column> -->
                <el-table-column :label="$t('派工单号')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.dispatchSn || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('客户名称')" align="center">
                    <template slot-scope="scope">
                        <span :title="scope.row.clientName">{{ scope.row.clientName || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('服务BU')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.buName || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('工程师')" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.engineerName || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('服务结果')" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.serviceMethod || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('服务日期')" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.leaveTime || '--' }}
                    </template>
                </el-table-column>
                <el-table-column :label="$t('报告日期')" align="center">
                    <template slot-scope="scope">
                        <span :title="scope.row.assistances">{{ scope.row.submittialTime || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('报告状态')" align="center">
                    <template slot-scope="scope">
                        <span>{{ dictionaryCom(scope.row.status, statusList) || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('操作')" align="center" width="150">
                    <template slot-scope="scope">
                        <div class="table_btn_box">
                            <button class="table_btn view" :title="$t('查看详情')" @click.stop="edit(scope.row)"></button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination_box">
                <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="pageInfo.page"
                        layout="total, prev, pager, next, jumper"
                        :total="pageInfo.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { DOMAIN } from "../../plugins/domain"
    import Cookie from 'js-cookie'
    import dictionary from "../../plugins/dictionary"
    import moment from 'moment'
    let createDateTo = moment().format('YYYY-MM-DD')
    let createDateFrom = moment().subtract(1, 'months').format('YYYY-MM-DD')
    export default {
        name: 'keep-alive',
        data () {
            return {
                loading: false,
                list: [],
                pageInfo: {
                  page: 1,
                  total: 0
                },
                parameters: {
                    parameters: {
                        dispatchSn: '',
                        clientName: '',
                        buId: '',
                        serviceTypeId: '',
                        status: '',
                        engineerName: '',
                        mtSn: '',
                        mtModel: '',
                        serviceMethod: '',
                        keyWord: '',
                        isWaitingForComponent: '',
                        isChangePart: '',
                        isBeingObserved: '',
                        createDateFrom,
                        createDateTo
                    }
                },
                statusList: dictionary.reportStatus, // 报告状态
                serviceMethodList: dictionary.serviceMethod, //服务方式
                clientAreaList: [],  // 服务区域
                serviceTypeList: [], // 服务类型
                booleanList: dictionary.boolean, // 是否
                exportData: {},
                buSelectOps: []
            }
        },
        mounted () {
            this.initMounted()
        },
        activated () {
            this.getList()
        },
        methods: {
            initMounted () {
                this.search()
                this.getBuList()
                this.getServiceTypeId()
            },
            getBuList () {
                this.$store.dispatch('a:bu/getBuList', {parameters: {}, page: 1, rows: 9999}).then(
                    res => {
                        this.buSelectOps = res.list
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            getServiceTypeId () {
                this.$store.dispatch('a:common/serviceTypeList', {}).then(
                    res => {
                        this.serviceTypeList = res
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            handleCurrentChange (val) {
                this.pageInfo.page = val
                this.getList()
            },
            search () {
                this.pageInfo.page =  1
                this.exportData = this.parameters.parameters
                this.getList()
            },
            getList () {
                this.loading = true
                let parameters = JSON.parse(JSON.stringify(this.parameters))
                this.$store.dispatch('a:searchServerList/read', {...parameters, page: this.pageInfo.page}).then(
                    res => {
                        this.list = res.list || []
                        this.loading = false
                        this.pageInfo = res.pageInfo
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                        this.loading = false
                    }
                )
            },
            edit (item) {
                this.$router.push({
                    path: '/searchServerListEdit',
                    query: {
                        id: item.id
                    }
                })
            },
            exportExcel () {
                let postData = {...this.exportData,iToken: sessionStorage.getItem('token')}
                let postData2 = ""
                for (var i in postData) {
                    postData2 += i + "=" + postData[i] + "&"
                }
                window.open(DOMAIN.fileFTP + "/file/serviceReportExcel?" + postData2 + "&language=" + Cookie.get('isesol_lang'))
            },
            // 字典对比
            dictionaryCom (index, list) {
                if (index || index === 0) {
                    for (let item of list) {
                    if (item.id === index) {
                        return item.name
                    }
                    }
                }
                return ''
            }
        }
    }
</script>
<style>
.sdWrap .form_box .input_box .el-input__icon,.sdWrap .el-date-editor .el-range-separator{
    line-height: 20px;
}
.sdWrap .el-date-editor .el-range-input{
    font-size: 12px;
}
</style>
<style lang="scss" scoped>
.basicData .form_box .form_box_line .form_box_line_item .input_box.w220{
    width: 220px;
}
.mailIcon{
    display: inline-block;
    width: 16px;
    height: 16px;
}
</style>
